module.exports = __webpack_public_path__ + "images/places/training_679-6c14a06bdbc6b2445108031f06416974.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./web/images/places/training_679.jpg
 ** module id = 323
 ** module chunks = 0
 **/